module.exports = __webpack_public_path__ + "assets/duanwujie.747c2a7e.svg";